import { useCallback, useEffect, useMemo } from 'react';
import { useRecoilState } from 'recoil';
import projectAtom from 'ProjectManager/Project/Common/recoil/project/projectAtom';
import axios from 'axios';
import giveProjectQuestionTextAnswer from 'ProjectManager/Project/Common/api/dataManagement/questionnaire/question/answer/giveProjectQuestionTextAnswer';
import withTextAnswerForQuestion from 'ProjectManager/DataManagement/Common/recoil/projectOrTemplate/modifiers/questionnaire/question/answer/withTextAnswerForQuestion';

const useProjectGiveTextAnswerFunction = (questionId, isCustomQuestion) => {
    const [{ id: projectId }, setProject] = useRecoilState(projectAtom);

    const source = useMemo(() => axios.CancelToken.source(), []);

    useEffect(
        () => () => {
            source.cancel();
        },
        [source],
    );

    // noinspection UnnecessaryLocalVariableJS
    const giveTextAnswer = useCallback(
        async textAnswer => {
            await giveProjectQuestionTextAnswer(
                projectId,
                questionId,
                isCustomQuestion,
                textAnswer,
                source.token,
            );

            setProject(
                withTextAnswerForQuestion(
                    questionId,
                    isCustomQuestion,
                    textAnswer,
                ),
            );
        },
        [projectId, questionId, isCustomQuestion, setProject, source.token],
    );

    return giveTextAnswer;
};

export default useProjectGiveTextAnswerFunction;
